import NavigateButton from "./componentes/NavigateButton/NavigateButton";
import PageItem from "./componentes/PageItem/PageItem";
import { 
    Container, 
    Content, 
    MorePages } from "./styles";

const Paginator = ({
    data = {
        currentPage: 1,
        quantityPages: 10
    }, changeData,
    alignSelf
}) => {
    const { currentPage, quantityPages } = data;
    const changeCurrentPage = value => {
        if (value < 1 || value > quantityPages) return;
        changeData(value);
    }
    const getPages = () => {
        return Array(
            quantityPages <= 5
            ? quantityPages 
            : 5).fill(0);
    }
    const renderPageItem = (_, idx) => {
        let page = idx + 1;
        if (quantityPages >= 6 && currentPage >= 5) {
            if (currentPage < quantityPages - 3)
                page += currentPage - 3;
            else 
                page += quantityPages - 5;
        }
        else if (currentPage > 4) {
            if (currentPage < quantityPages - 3)
                page += currentPage - 1;
            else 
                page += quantityPages - 5;
        }
        return (
            <PageItem key={idx}
                page={page}
                selected={currentPage === page}
                changeCurrentPage={changeCurrentPage}/>
        );
    }
    return (
        <Container alignSelf={alignSelf}>
            <NavigateButton 
                firstOrLast={currentPage === 1}
                tooltipText="Página anterior"
                changeCurrentPage={() => {
                    changeCurrentPage(currentPage - 1);
                }}/>
            <Content>
                {(quantityPages > 5 && currentPage >= 5) && (
                    <>
                        <PageItem 
                            page={1}
                            selected={currentPage === 1}
                            changeCurrentPage={changeCurrentPage}/>
                        <MorePages>...</MorePages>
                    </>
                )}
                {getPages().map(renderPageItem)}
                {(quantityPages > 5 && quantityPages - currentPage > 3) && (
                    <>
                        <MorePages>...</MorePages>
                        <PageItem 
                            page={quantityPages}
                            selected={currentPage === quantityPages}
                            changeCurrentPage={changeCurrentPage}/>
                    </>
                )}
            </Content>
            <NavigateButton 
                firstOrLast={currentPage === quantityPages} 
                next
                tooltipText="Página siguiente"
                changeCurrentPage={() => {
                    changeCurrentPage(currentPage + 1);
                }}/>
        </Container>
    );
}

export default Paginator;